import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
import { fetchRpmFrequenciesList } from '../../../../../Redux/actions/rpmActions';
import FrequencyListTable from './frequenciesListTable';

function Index() {
    const [currentPage, setCurrentPage] = useState(1);
    const { isLoading, frequenciesList } = useSelector((state) => state.rpm);
    const dispatch = useDispatch();

    useEffect(() => {
        const payload = {
            status: 1
        }
        dispatch(fetchRpmFrequenciesList(payload));
    }, []);

    return (
        <div>
            <div className={`${isLoading === false && frequenciesList?.length === 0 ? 'w-full flex justify-center items-center' : 'overflow-y-scroll h-[23rem] scrollWidth'}`}>
                {isLoading && frequenciesList?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]">
                        <Flex align="center" gap="middle">
                            <Spin size="large" tip="Loading" />
                        </Flex>
                    </div>
                ) :
                    frequenciesList?.length === 0 ?
                        (<div className="flex flex-col items-center justify-center">
                            <img src={nodatafound} alt="nodatafound" className="h-min w-min" />
                            <p className="font-medium text-xl">No data found!!</p>
                        </div>)
                        :
                        (
                            <div>
                                <FrequencyListTable
                                    data={frequenciesList}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    totalCount={frequenciesList?.length}
                                />
                            </div>
                        )}

            </div>
        </div>
    )
}

export default Index;